// init controller
var controller = new ScrollMagic.Controller(
	// {addIndicators: true}
);

var theScene = function(trigElem){
	new ScrollMagic.Scene({triggerElement: trigElem, triggerHook: 0.7})
		.setClassToggle(trigElem, "is-active") // add class toggle
		.addTo(controller);
}

$('.magic').each(function(i){
	trigClass = ".scene-" + i;
	$(this).addClass(trigClass);
	theScene(this);
});
